"use client"

import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import Table from "../../components/Table"
import routes from "../../routes/URL"
import Header from "../../components/Header"
import Toast from "../../components/Toast"
import ConfirmationModal from "../../components/ConfirmationModal"
import axios from "axios"

const ColorScheme = {
  buttonColor: "#FFC857",
  bgColor: "#02111B",
  componentColor: "#07070A",
  accentColor: "#BB0A21",
  textColor: "#FFFFFF",
}

class ListHotelScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      version: 1,
      selectedRows: [],
      isBulkDeleteConfirmationModalOpen: false,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  onDelete = async (item) => {
    console.log( "item in the delete" ,item.id)
    const { status, message } = await API(this, "post", URL_PATH.deleteHall(item.id))
    console.log("url in the delete", URL_PATH.deleteHall(item.id))
    

    if (status === "success") {
      this.setState({
        version: this.state.version + 1,
        toast: {
          open: true,
          message: message,
          severity: "success",
        },
      })
    } else {
      this.setState({
        toast: {
          open: true,
          message: message,
          severity: "error",
        },
      })
    }
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  onEdit = (item) => {
    console.log("item in the edit", item)
    console.log(item.floor_no, item.id)
    this.props.history.push(routes.admin.halls.update(this.props.hotels[0].hotel_slug,item.slug,item.id))
  }

  // onView = (item) => {
  //   console.log(item.floor_no, item.id)
  //   this.props.history.push(routes.admin.floors.show(item.floor_no, item.id))
  // }

  // Handle selected rows change from Table component
  handleSelectedRowsChange = (selectedRows) => {
    this.setState({ selectedRows })
  }

  // Open bulk delete confirmation modal
  openBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: true })
  }

  // Close bulk delete confirmation modal
  closeBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: false })
  }

  // Handle bulk delete confirmation
  handleBulkDeleteConfirmation = async () => {
    await this.onBulkAction(this.state.selectedRows)
    this.closeBulkDeleteConfirmationModal()
  }


  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
 
  }

  // Bulk delete action

      onBulkAction = async (rows) => {
        const ids = Object.values(rows)
        const token = localStorage.getItem("token")
        
        const { status, message, data } = await API(this, "post", URL_PATH.deleteBulkFloor(this.props.selectedHotelId.id),{ids})
        if (status === "success") {
          this.showToast(message, "success")
        this.setState({
              version: this.state.version + Math.random() + "",
              selectedRows: [],
            })
        } else {
          this.showToast(message, "error")
        }
    
      }

  render() {
    const { selectedRows, isBulkDeleteConfirmationModalOpen } = this.state

    return (
      <div className="container-fluid">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Header title="Hall" />
          <div style={{ display: "flex", flexDirection: "row" }}>
            {selectedRows.length > 0 && (
              <button
                className="btn mr-2"
                style={{
                  backgroundColor: ColorScheme.accentColor,
                  color: ColorScheme.textColor,
                  marginRight: "10px",
                }}
                onClick={this.openBulkDeleteConfirmationModal}
              >
                <i className="fa fa-trash mr-1" aria-hidden="true"></i> Delete Selected ({selectedRows.length})
              </button>
            )}
            <div
              className="btn"
              style={{ backgroundColor: "#FFC857", color: "#000", fontWeight: "700" }}
              onClick={() => {
                this.props.history.push(routes.admin.halls.create(this.props.hotels[0].hotel_slug))
              }}
            >
              +ADD HAll
            </div>
          </div>
        </div>

        <Table
          key={this.state.version}
          api={URL_PATH.hallList}
          onEdit={this.onEdit}
          searchPlaceholder="Search by hall"

          // onView={this.onView}
          deleteText="Delete Space will delete all tables associated with it"
          onDelete={this.onDelete}
          onSelectedRowsChange={this.handleSelectedRowsChange}
          selectedHotelId={this.props.selectedHotelId}
          row={[
            // { title: "Id", key: "id", sortable: true },
            { title: "Hall Name", key: "hall_name", sortable: true },
            { title: "Capacity", key: "capacity", sortable: false },
          ]}
        />

        {/* Bulk Delete Confirmation Modal */}
        <ConfirmationModal
          isOpen={isBulkDeleteConfirmationModalOpen}
          onConfirm={this.handleBulkDeleteConfirmation}
          onCancel={this.closeBulkDeleteConfirmationModal}
          title="Confirm Bulk Deletion"
          message={`Are you sure you want to delete the selected ${selectedRows.length} spaces? This will also delete all tables associated with these spaces.`}
          confirmText="Yes, delete them!"
          cancelText="Cancel"
        />

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
      </div>
    )
  }
}

export default redux(ListHotelScreen)
